import {clsx} from '@gfiber/typesmith';
import styles from './List.module.scss';

interface ListProps {
  children: React.ReactNode;
  className?: string;
  tag?: 'ul' | 'ol';
  testId?: string;
}

export const List: React.FC<ListProps> = ({
  children,
  className,
  tag: Tag = 'ul',
  testId,
}) => {
  const classes = clsx(styles.list, className);

  return (
    <Tag
      className={classes}
      data-testid={testId}
    >
      {children}
    </Tag>
  );
};
